<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="4"
      cy="12"
      r="2.5"
      fill="currentColor"
    />
    <circle
      cx="12"
      cy="12"
      r="2.5"
      fill="currentColor"
    />
    <circle
      cx="20"
      cy="12"
      r="2.5"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Ellipsis' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
